import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const RecycleBin = () => {
  const [documents, setDocuments] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    fetchDeletedDocuments();
  }, []);

  const fetchDeletedDocuments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-docs?isDeleted=true`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setDocuments(response.data);
    } catch (error) {
      console.error(
        "Error fetching deleted docs:",
        error.response?.data || error.message
      );
    }
  };

  const handleRestore = async (id) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/restore-doc/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      Swal.fire("Restored!", "Document has been restored.", "success");
      fetchDeletedDocuments();
    } catch (error) {
      console.error("Error restoring doc:", error);
    }
  };

  const handlePermanentDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the document!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete permanently",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(
            `${process.env.REACT_APP_API_URL}/api/permanent-delete/${id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          Swal.fire("Deleted!", "Document permanently deleted.", "success");
          fetchDeletedDocuments();
        } catch (error) {
          console.error("Error deleting doc:", error);
        }
      }
    });
  };

  // Pagination logic
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(filteredDocs.length / perPage);
  const currentDocs = filteredDocs.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  return (
    <div className="card shadow-lg p-4 bg-light table-responsive">
      <h2 className="text-danger text-center mb-3">Recycle Bin</h2>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <input
          type="text"
          placeholder="Search by Title"
          className="form-control w-50"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          className="form-select w-auto"
          value={perPage}
          onChange={(e) => {
            setPerPage(parseInt(e.target.value));
            setCurrentPage(1);
          }}
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n} per page
            </option>
          ))}
        </select>
      </div>

      <table className="table table-striped table-hover text-center">
        <thead className="table-dark">
          <tr>
            <th>S.N.</th>
            <th>Title</th>
            <th>Issue Date</th>
            <th>Expiry Date</th>
            <th>Contact Number</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentDocs.map((doc, index) => (
            <tr key={doc._id}>
              <td>{(currentPage - 1) * perPage + index + 1}</td>
              <td>{doc.title}</td>
              <td>{doc.issueDate?.split("T")[0]}</td>
              <td>{doc.expiryDate?.split("T")[0]}</td>
              <td>{doc.concernPersonPhone}</td>
              <td>
                <a
                  href={`${process.env.REACT_APP_API_URL}/${doc.filePath}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-info fw-bold me-2"
                >
                  Read
                </a>
                <button
                  className="btn btn-sm btn-success fw-bold me-2"
                  onClick={() => handleRestore(doc._id)}
                >
                  Restore
                </button>
                <button
                  className="btn btn-sm btn-danger fw-bold"
                  onClick={() => handlePermanentDelete(doc._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span>
          Page{" "}
          <strong>
            {currentPage} / {totalPages || 1}
          </strong>
        </span>

        <button
          className="btn btn-secondary"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RecycleBin;
